import { render, staticRenderFns } from "./bank-order-list.vue?vue&type=template&id=3121838e&scoped=true"
import script from "./bank-order-list.vue?vue&type=script&lang=js"
export * from "./bank-order-list.vue?vue&type=script&lang=js"
import style0 from "./bank-order-list.vue?vue&type=style&index=0&id=3121838e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3121838e",
  null
  
)

export default component.exports